<template>
  <div class="zmbiz-mobile-container">
    <page-back ref="pageBack"> </page-back>

    <transition :name="transitionName">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import PageBack from "@components/page-back/page-back.vue";
import pageBackMixins from "@mixins/page-back.js";
import routerAnimationMixins from "@mixins/router-animation.js";

export default {
  mixins: [pageBackMixins, routerAnimationMixins],
  components: {
    PageBack,
  },
  created() {
    service.HomePageAddress.set(window.location.href);
  },
  mounted() {
    window.setTimeout(() => {
      const docElementFontSize = document.documentElement.style.fontSize;
      const finalDocElementFontSize = window
        .getComputedStyle(window.document.documentElement)
        .getPropertyValue("font-size");

      console.log("原字体:", docElementFontSize);
      console.log("现字体:", finalDocElementFontSize);
    }, 2000);
  },
};
</script>

<style lang="scss">
@import "./assets/css/var.scss";
.zmbiz-mobile-container {
  max-width: 750px;
  min-width: 320px;
  margin: 0 auto;
  height: 100%;
}
</style>
